<template>
  <div class="box">
    <h3 class="title">
      <img src="../../../assets/images/icon_wwfwl.png" alt="">
      <p>争议订单追差详情</p>
      <span>({{ extraDetatil.state == '00' ? '待审核' : extraDetatil.state == '10' ? '待复核' : extraDetatil.state == '20' ?
        '已打款' : '已驳回'
      }})</span>
    </h3>
    <!--信息-->
    <div>
      <ProcessHeader :isMatrix="isMatrix" :detail-data="detailData" :info-data="infoData"
        @matrixSwitch="(v) => matrixSwitch(v)" />
    </div>

    <!-- 进度 -->
    <div>
      <div class="store_box">
        <!-- 进度条区*** -->
        <div class="store_line">

          <template>
            <div v-if="detailData.pview.auditFirstTime || detailData.state === '00' || detailData.rejectMark === '00'"
              class="style_line"
              style="max-width: calc(40vw + 22px);min-width: calc(40vw + 22px);width: calc(40vw + 22px)">
              <div>1</div>
              <div>平台审核</div>
              <div class="progress_bar"></div>
            </div>
          </template>
          <div class="style_line" v-if="detailData.state === '10' || detailData.state === '20'">
            <div v-if="detailData.pview.auditFirstTime">2</div>
            <div v-if="!detailData.pview.auditFirstTime">1</div>
            <div>追差关闭</div>
          </div>
          <template v-else>
            <div class="style_line">
              <div>2</div>
              <div>门店打款</div>
              <div class="progress_bar"></div>
            </div>
            <div class="style_line">
              <div>3</div>
              <div>追差完成</div>
            </div>
          </template>
        </div>
        <!-- 内容区** -->
        <div class="store_inner">
          <div class="store_main_style">

            <!-- 平台审核 -->
            <template>
              <div class="store_result_style pla_result_style" style="display: flex;width: 60%;"
                v-if="detailData.pview.auditFirstTime || detailData.state === '00' || detailData.rejectMark === '00'">
                <template>
                  <!-- 初审 -->
                  <div class="store_result_first">
                    <div v-if="detailData.state === '00'" class="store_result_style empty">
                      <img src="../images/img_ddsh_.png" alt="">
                      <p class="inner_label">等待初审</p>
                    </div>
                    <div v-else class="store_result_first_line" style="padding-right: 30px;">
                      <div class="inner_line">
                        <p>平台初审</p>
                      </div>
                      <div class="inner_line" style="justify-content: space-between;align-items: center">
                        <div class="inner_line" style="margin-bottom: 0;margin-right: 5px;">
                          <p class="inner_label">审核判责：</p>
                          <p>{{ detailData.undertakeSubjectText }}</p>
                        </div>
                        <!-- v-if="detailData.pview.rejectMark !== '00'" -->
                        <p class="click_hover inner_href_text" @click="firstJudgements">
                          初审判责依据</p>
                      </div>
                      <div class="inner_line">
                        <p class="inner_label">初审人：</p>
                        <p>{{ detailData.auditFirstAdminName }}-{{ detailData.auditFirstAdminAcc }}</p>
                      </div>
                      <div class="inner_line">
                        <p class="inner_label">初审时间：</p>
                        <p>{{ detailData.pview.auditFirstTime || detailData.pview.closeTime }}</p>
                      </div>
                      <div class="inner_line" style="margin-bottom: 0;">
                        <p class="inner_label">初审通过金额：</p>
                        <p>￥{{ detailData.pview.arguePriceAuditS || '--' }}</p>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 复核 -->
                <template>
                  <div>
                    <div
                      v-if="detailData.rejectMark === '01' || detailData.rejectMark === '00' || !detailData.pview.auditReAdminTime"
                      class="store_result_style empty" style="width: 100%;max-width: 100%;min-width: 100%;">
                      <img src="../images/img_ddsh_.png" alt="">
                      <p class="inner_label" v-if="detailData.state === '20' && !detailData.pview.auditReAdminTime">
                        追差关闭，无法复核</p>
                      <p class="inner_label"
                        v-else-if="detailData.state === '10' && !detailData.pview.auditReAdminTime">
                        追差关闭，无法复核</p>
                      <p class="inner_label" v-else>等待复核</p>
                    </div>
                    <div v-else style="margin-left: 30px;">
                      <div class="inner_line">
                        <p>平台复核</p>
                      </div>
                      <div class="inner_line">
                        <p class="inner_label">复核人：</p>
                        <p>{{ detailData.auditReAdminName }}-{{ detailData.auditReAdminAcc }}</p>
                      </div>
                      <div class="inner_line">
                        <p class="inner_label">复核时间：</p>
                        <p>{{ detailData.pview.auditReAdminTime }}</p>
                      </div>
                      <div class="inner_line" style="margin-bottom: 0;">
                        <div><span class="inner_label">复核打款金额：</span><span>{{ detailData.rePayPrice }}元</span>
                        </div>
                      </div>
                      <!-- <div style="margin-top: 10px;" class="inner_href_text click_hover"
                        v-if="detailData.deBalanceVoucher !== '--'" @click="viewVoucher">
                        查看沟通凭证
                      </div> -->
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <!-- 门店打款 -->
            <div class="store_result_style" v-if="detailData.state === '04'">
              <div class="inner_line">
                <p>已完成打款({{ detailData.moneyWay === '00' ? '线下打款' : '线上打款' }})</p>
              </div>
              <div class="inner_line">
                <p class="inner_label">打款人：</p>
                <!-- detailData.payWay === '00'"门店打款 -->
                <div v-if="detailData.payWay === '00'">{{ detailData.payStaffName || '--' }}</div>
                <!-- 平台打款 -->
                <div v-else-if="detailData.payWay === '01'">{{ detailData.auditReAdminName }}-{{
                  detailData.auditReAdminAcc
                }}（平台直接操作）
                </div>
                <!-- 系统自动打款 -->
                <div v-else-if="detailData.payWay === '02'">超时系统自动打款</div>
                <div v-else>--</div>
              </div>
              <div class="inner_line">
                <p class="inner_label">打款时间：</p>
                <div v-if="detailData.payWay === '01'">{{ detailData.pview.auditReAdminTime || '--' }}</div>
                <div v-else>{{ detailData.payTime }}</div>
              </div>
              <div class="inner_line">
                <p class="inner_label">已打款金额：</p>
                <p>￥{{ detailData.deStoreBalance }}</p>
                <!-- <p style="color: red;text-decoration: underline;cursor: pointer;"
                  v-if="detailData.aprExtraPrice != '--'" @click=" openAction(`/difference/platformExtra`)">额外补差{{
                    detailData.aprExtraPrice }}元</p> -->
              </div>
            </div>
            <div v-else class="store_result_style empty"
              v-show="!(detailData.state === '10' || detailData.state === '20')">
              <img src="../images/img_ddsh_.png" alt="">
              <p class="inner_label">等待打款</p>
            </div>
            <!-- 追差完成 -->
            <div class="store_result_style" v-if="detailData.state === '04'">
              <div class="inner_line">
                <p>追差完成,{{ detailData.moneyWay === '00' ? '线下打款' : '线上打款' }}</p>
              </div>
            </div>
            <div v-else v-show="!(detailData.state === '10' || detailData.state === '20')"
              class="store_result_style empty">
              <img src="../images/img_ddsh_.png" alt="">
              <p class="inner_label">暂无数据</p>
            </div>
            <!-- 追差关闭 -->
            <div class="store_result_style" v-if="detailData.state === '10' || detailData.state === '20'">
              <div class="inner_line">
                <p>{{ detailData.rejectMark === '00' ? '初审驳回' :
                  detailData.rejectMark === '01' ? '平台复核驳回' :
                    detailData.rejectMark === '02' ? '门店打款驳回' :
                      detailData.rejectMark === '03' ? '门店审核驳回' : '回收商撤回申请'
                }}，追差关闭，请重新整理依据</p>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- <div class="recommendation_box" >

        <div class="store_recommendation">
          <div class="info_title">回收商报价建议</div>
          <div class="result_data_main">{{ detailData.merchantSuggest }}</div>
        </div>
      </div> -->
    </div>

    <!-- 提交争议补差申请 -->
    <div class="check_money_box">
      <div class="check_money_title">
        <p class="info_title">
          提交争议补差申请</p>
      </div>
      <div style="padding: 10px; font-size: 13px;">
        <el-row>
          <el-col :span="6">
            提交时间：<span style="color: #4C84FF;">{{ extraDetatil.applyTime }}</span>
          </el-col>
          <el-col :span="6">
            提交人： <span style="color: #4C84FF;">{{ extraDetatil.applyStaffName }}-{{ extraDetatil.applyStaffMobile
            }}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 50px;">
          <el-col :span="6">
            申请金额： <span style="color: #4C84FF;">{{ extraDetatil.applyPrice }}元</span>
          </el-col>
          <el-col :span="6">
            申请原因： <span style="color: #4C84FF;">{{ extraDetatil.applyNote }}</span>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 运营初步审核 -->
    <div class="check_money_box">
      <div class="check_money_title">
        <p class="info_title">
          运营初步审核</p>
      </div>
      <el-row style="display: flex; ">
        <el-col :span="8">
          <div style="margin-bottom: 20px;">
            <label class="responsibility_title" for="arguePriceAudit"><span
                style="color: #ff8080;">*</span>运营处理意见：</label>
            <el-radio :disabled="auditFirstDisabled" v-model="extraForm.auditFirstIfPass" :label="true">通过</el-radio>
            <el-radio :disabled="auditFirstDisabled" v-model="extraForm.auditFirstIfPass" :label="false">驳回</el-radio>
          </div>
          <div v-if="extraForm.auditFirstIfPass">
            <label class="responsibility_title" for="arguePriceAudit"><span
                style="color: #ff8080;">*</span>审核通过金额:</label>
            <el-input :disabled="auditFirstDisabled" style="width: 178px;margin-right: 12px;" name="arguePriceAudit"
              :value="extraForm.auditFirstPrice" type="number"
              @input="v => extraForm.auditFirstPrice = getFloat2Value(v, Number(this.extraDetatil.applyPrice)) <= 0 ? 0 : getFloat2Value(v, Number(this.extraDetatil.applyPrice))"
              placeholder="请输入审批追差金额" minlength="1" />
            <span>元</span>
          </div>
          <div v-else>
            <label class="responsibility_title" for="arguePriceAudit"><span
                style="color: #ff8080;">*</span>驳回原因:</label>
            <el-input :disabled="auditFirstDisabled" style="margin-top: 10px;" type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="extraForm.rejectCause" maxlength="200"
              show-word-limit>
            </el-input>
          </div>
        </el-col>
        <el-col :span="8" style="display: flex;align-items: flex-end;padding-bottom: 10px;" v-if="auditFirstDisabled">
          <span style="margin-right: 15px;">初审人：{{ extraDetatil.auditFirstAdminName }}-{{ extraDetatil.auditFirstAdminAcc
          }}</span>
          <span>初审时间：{{ extraDetatil.auditFirstTime}}</span>
        </el-col>
      </el-row>
    </div>

    <!-- 复核打款 -->
    <div class="check_money_box" v-if="auditReShow">
      <div class="check_money_title">
        <p class="info_title">复核打款</p>
        <p v-if="extraForm.moneyWay === '01'">（本单线上结算差异款）</p>
        <p v-else style="color:#4C84FF">（本单线下结算差异款）</p>
      </div>
      <div class="check_money_main">
        <!-- 复核打款 -->
        <div class="money_original" style="margin-top: 0;">
          <el-row style="display: flex; ">
            <el-col :span="8">
              <div style="margin-bottom: 20px;">
                <label class="responsibility_title" for="arguePriceAudit"><span
                    style="color: #ff8080;">*</span>复核处理意见：</label>
                <el-radio :disabled="auditReDisabled" v-model="extraForm.auditReIfPass" :label="true">通过</el-radio>
                <el-radio :disabled="auditReDisabled" v-model="extraForm.auditReIfPass" :label="false">驳回</el-radio>
              </div>
              <div v-if="extraForm.auditReIfPass">
                <label class="responsibility_title" for="arguePriceAudit"><span
                    style="color: #ff8080;">*</span>复核打款金额：</label>
                <el-input :disabled="auditReDisabled" style="width: 178px;margin-right: 12px;" name="arguePriceAudit"
                  :value="extraForm.rePayPrice" type="number"
                  @input="v => extraForm.rePayPrice = getFloat2Value(v, Number(this.extraDetatil.applyPrice)) <= 0 ? 0 : getFloat2Value(v, Number(this.extraDetatil.applyPrice))"
                  placeholder="请输入审批追差金额" minlength="1" />
                <span>元</span>
              </div>
              <div v-else>
                <label class="responsibility_title" for="arguePriceAudit"><span
                    style="color: #ff8080;">*</span>驳回原因:</label>
                <el-input :disabled="auditReDisabled" style="margin-top: 10px;" type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="extraForm.rejectCause"
                  maxlength="200" show-word-limit>
                </el-input>
              </div>
            </el-col>
            <el-col :span="8" style="display: flex;align-items: center;padding-top: 36px;margin-left: 10px;"
              v-if="auditReDisabled">
              <span style="margin-right: 15px;">复核人：{{ extraDetatil.auditReAdminName }}-{{ extraDetatil.auditReAdminAcc
              }}</span>
              <span>复核时间：{{ extraDetatil.auditReAdminTime }}</span>
            </el-col>
          </el-row>
        </div>

        <div v-if="extraForm.auditReIfPass">
          <div style="margin-top: 24px;">
            <label class="responsibility_title" for="arguePriceAudit" style="margin-right: 15px;"><span
                style="color: #ff8080;">*</span>打款方式：</label>
            <el-radio-group :disabled="auditReDisabled" v-model="extraForm.moneyWay">
              <el-radio :label="'01'" :disabled="(extraForm.arguePriceAudit == 0) ? true : false">线上打款</el-radio>
              <el-radio :disabled="(extraForm.arguePriceAudit == 0) ? true : false" :label="'00'">线下打款</el-radio>
            </el-radio-group>
          </div>
          <!-- 线上打款 -->
          <!-- 使用差异基金 -->
          <div v-if="extraForm.moneyWay === '01'">
            <div class="switch_money_origin money_original" style="display: flex;align-items: center">
              <el-switch :disabled="auditReDisabled" style="margin-right: 12px" v-model="isFund">
              </el-switch>
              <label class="responsibility_title" for="diffFundPrice">
                使用差异基金
                <span v-if="detailData.outType === 'fx'" style="color: #999">（矩阵原订单商户实际差异基金：<span
                    style="color: #FD677D;">{{
                      detailData.oriDiffFundBalanceReal || 0 }}</span>元，差异基金账户余额：{{
                      detailData.oriDiffFundPriceAccount || 0 }}元）</span>
                <span v-else style="color: #999">（当前商户实际差异基金：<span style="color: #FD677D;">{{
                  detailData.diffFundBalanceReal }}</span>，账户余额{{ detailData.diffFundPriceAccount }}元）</span>

              </label>
              <el-input style="width: 200px;margin-right: 12px;" name="diffFundPrice"
                :disabled="!isDiffFundPrice || auditReDisabled" v-model="extraForm.diffFundPrice" type="number"
                @input="inputDiffFundPrice" placeholder="请输入使用基金补差金额" minlength="1" />

              <span>元</span>
              <!-- 新增：统计 -->
              <div class="statatics">
                平台差异基金：<span style="color:red">{{ allDiffFund }}</span>元；该回收商净入账差异基金：<span style="color:red">{{
                  merchantDiffFund }}</span>元 <el-button style="margin-left: 15px;" type="warning" size="mini"
                  @click="refreshData">刷新</el-button>
              </div>
            </div>
            <!-- 商户余额扣除 外部订单选择线上打款，默认屏蔽扣除商户余额模块 -->
            <!-- <div v-if="extraForm.moneyWay == '01' && (detailData.outType == 'fx' || detailData.outType == '--')"
              class="switch_money_origin money_original" style="display: flex;align-items: center">
              <el-switch :disabled="auditReDisabled" style="margin-right: 12px" v-model="isDeBalanceVoucher"
                @change="isDeBalanceVoucherChange">
              </el-switch>
              <label class="responsibility_title" for="deStoreBalance">
                扣除商户余额
                <i style="color: #FD677D;font-style: normal">(谨慎操作)</i>:
                <span v-if="detailData.outType === 'fx'" style="color: #999">（矩阵原订单商户余额：{{
                  detailData.oriBalance || '--'
                }}元）</span>
                <span v-else style="color: #999">
                  （当前商户账户余额：{{ detailData.balance }}元
                  <span v-if="detailData.outType !== 'fx' && detailData.outType !== '--'">，本单订单利润：{{
                    accAdd(detailData.rebateAfter, detailData.rebateDepreciate)
                  }}元</span>）
                </span>
              </label>
              <el-input v-if="detailData.outType === 'fx' || detailData.outType === '--'" disabled
                style="width: 200px;margin-right: 12px;" name="deStoreBalance" v-model="extraForm.deStoreBalance"
                type="number" placeholder="请输入扣除商户余额" minlength="1" />
              <el-input v-else disabled style="width: 200px;margin-right: 12px;" name="deStoreBalance"
                v-model="extraForm.deStoreBalance" type="number" placeholder="请输入扣除商户余额" minlength="1" />
              <span>元</span>
              <span v-if="isDeBalanceVoucher && !auditReDisabled" class="inner_href_text" style="margin-left: 17px;"
                @click="deBalanceVoucherProps.show = true; deBalanceSumit.isEdit = true;">修改扣款余额</span>
            </div> -->
          </div>
          <!-- 线下打款 -->
          <div v-if="extraForm.moneyWay === '00'" style="margin-top: 30px;">
            <label class="responsibility_title" for="arguePriceAudit"><span
                style="color: #ff8080;">*</span>线下打款金额：</label>
            <el-input style="width: 178px;margin-right: 12px;" name="arguePriceAudit" :value="extraForm.rePayPrice"
              type="number" disabled>
            </el-input><span>元</span>
            <div style="color: #ff8080;margin-top: 10px;">线下打款金额默认复核打款金额</div>
          </div>
        </div>

      </div>
    </div>

    <el-button :loading="submitLoading" v-if="extraDetatil.state == '00' || extraDetatil.state == '10'" type="primary"
      @click="submitDialog" style="margin: 15px;">提交处理结果</el-button>

    <el-dialog title="
操作提示" :visible.sync="submitVisible" width="30%" :before-close="() => submitVisible = false">
      <div
        style="font-weight: 900;width: 100%;display: flex;justify-content: center;align-items: center;height: 100px;">
        是否确认提交处理接口
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 初审判责依据 -->
    <DialogAction v-bind="firstRejectProp" @config="firstRejectProp.show = false" @close="firstRejectProp.show = false">
      <div class="rejetct_box">
        <div class="reject_duty">
          <div style="margin-right: 10px;">审批判责：</div>
          <el-radio disabled>{{ firstRejectProp.rejectText }}</el-radio>
        </div>
        <div class="responsibility_category" v-if="firstRejectProp.undertakeSubject === 'T'">
          <p :class="[firstRejectProp.tabSquare === '01' ? 'responsibility_category_active' : '']"
            @click="tabSquareClick('01')">
            门店依据</p>
          <p :class="[firstRejectProp.tabSquare === '02' ? 'responsibility_category_active' : '']"
            @click="tabSquareClick('02')">
            回收商判责</p>
        </div>
        <div class="reject_basis">
          <JudgementsList :source-data="firstRejectProp.sourceData" state="01"
            :assignment-data="firstRejectProp.assignmentData" />
        </div>
      </div>
    </DialogAction>

    <!-- 确认扣钱商户余额 -->
    <DialogAction v-bind="deBalanceVoucherProps" @close="deBalanceVoucherClose" @config="diffFundConfig">
      <template v-slot:from>
        <div class="money_original" style="margin-top: 0;">
          <label class="responsibility_title element_xing" for="arguePriceAudit">确认门店扣款金额：</label>

          <el-input :disabled="deBalanceVoucherProps.isView" style="width: 200px;margin-right: 12px;"
            name="arguePriceAudit" :value="deBalanceSumit.money" type="number"
            @input="v => deBalanceSumit.money = getFloat2Value(v) <= 0 ? 0 : getFloat2Value(v)" placeholder="请输入门店扣款金额"
            minlength="1" />
          <span>元</span>
        </div>
        <p v-if="detailData.outType === 'fx'" style="color: #333;font-size: 12px">({{
          detailData.oriCompanyName || '--'
        }}：{{ detailData.oriBalance || '--' }}元)</p>
        <p v-else style="color: #333;font-size: 12px">({{ detailData.currentCompanyName || '--' }}：{{
          detailData.balance || '--'
        }}元)</p>
        <!-- 凭证 -->
        <div class="voucher_box element_xing">
          <p>上传沟通凭证</p>
          <div v-if="!deBalanceVoucherProps.isView">
            <!-- 上传 -->
            <UploadElement v-bind="{ existImage: deBalanceSumit.voucher }" :exist-image="deBalanceSumit.voucher"
              @handleDelete="deBalanceSumit.voucher = ''" @handleChange="v => deBalanceSumit.voucher = v" />
          </div>
          <div v-else>
            <el-image style="width: 118px; height: auto;border: 1px dashed #C1CBFF;" :src="deBalanceSumit.voucher"
              :preview-src-list="[deBalanceSumit.voucher]">
            </el-image>
          </div>
        </div>
      </template>
    </DialogAction>

  </div>
</template>
<script>
import { imeiTestProps } from "@/views/RecallOrder/initState";
import {
  deBalanceVoucherProps,
} from "@/views/difference/platformReview/initState";
import {
  getAprState,
  getAprStateStore,
  getFloat2Value,
  getRejectMark,
  getUndertakeSubject,
  infoConcat,
  setValue,
  openAction
} from "@/utils/common";

import _api from "@/utils/request";
import http from "@/utils/request/platformExtra";

import DialogAction from "@/components/common/DialogAction.vue";
import JudgementsList from "@/views/difference/componets/JudgementsList.vue";
import ProcessHeader from "@/views/difference/componets/ProcessHeader.vue";
import UploadElement from "@/components/global/components/elements/upload-element.vue";

export default {
  components: { ProcessHeader, DialogAction, JudgementsList, UploadElement },
  data() {
    const resetData = [
      {
        url: "",
        reason: "",
        judgeType: ""
      }
    ];
    const { argueNo, argueNoExtra } = this.$route.query;

    return {
      // 订单号
      argueNo,
      argueNoExtra,
      radio: '',
      textarea2: '',
      // 打款方式
      moneyWay: '',
      allDiffFund: 0,//当前总差异基金
      merchantDiffFund: 0,//回收商总差异基金


      isLimitApply: false,//是否限制本单继续追差

      imeiTestProps,
      // 共同承担，tab控制,01门店，02：回收商
      tabSquare: '',


      assignmentData: [],
      // 共同承担 门店依据
      storeJudgements: resetData,
      // 共同承担 回收商依据
      recoveryJudgements: resetData,
      // 上传依据直接赋值操作
      submitData: {
        rePayPrice: '',//复核金额
        deStoreBalance: null,//余额
        diffFundPrice: null,//差异基金
        undertakeSubject: "",//判责
        // 判责依据
        judgements: [],
        // 追差金额
        arguePriceAudit: "",
        // 回收商建议
        merchantSuggest: "",
        // 门店商建议
        companySuggest: ""
      },
      // 余额扣除
      isDeBalanceVoucher: false,
      // 差异基金开启状态
      isDiffFundPrice: true,
      // 差异基金提交数据
      deBalanceSumit: {
        voucher: "",
        money: null,
        isEdit: false,
      },
      deBalanceVoucherProps,

      // 详情数据
      detailData: {},
      flowData: {},
      // 订单信息
      infoData: {
        funcDetail: {},
        sku: { skus: [] },//外部规格
      },
      // 切换矩阵
      isMatrix: false,
      residueTime: "",
      // 清楚定时器
      timer: null,

      firstRejectProp: {
        show: false,
        title: "初审判责依据",
        judgements: [],
        rejectText: "",
        tabSquare: "01",
        assignmentData: [],
        undertakeSubject: "",
        sourceData: [],
      },
      extraDetatil: {},
      extraForm: {
        auditFirstIfPass: true,
        auditFirstPrice: '',
        rePayPrice: '',
        arguePriceAudit: '',
        rejectCause: '',
        auditReIfPass: true
      },
      auditFirstDisabled: true,
      auditReShow: true,
      auditReDisabled: true,
      isFund: false,
      submitVisible: false,
      submitLoading: false
    }
  },
  computed: {
    adminButton() {
      return this.$store.state.tagsView.adminButton
    },
  },
  watch: {
    // 监听依据商户类型切换
    tabSquare(v) {
      // 门店
      if (v === '01') {
        this.assignmentData = this.storeJudgements;
      }
      // 回收商
      if (v === '02') {
        this.assignmentData = this.recoveryJudgements;
      }
    },

    // 差异基金
    isDiffFundPrice(v) {
      console.log(this.detailData, '6666666');
      if (v) {
        // 矩阵原订单基金
        // 原：加了&& Number(this.detailData.oriDiffFundPriceAccount) <= 0
        if (this.detailData.state === '01' && this.detailData.outType === 'fx') {
          // this.isDiffFundPrice = false;
          // return this.$message.error("当前差异基金金额为0，不可设置")
        }
        // 订单基金
        // 原：this.detailData.state === '01' && this.detailData.state === '01' && this.detailData.outType === '--'&& Number(this.detailData.diffFundPriceAccount) <= 0
        if (this.detailData.outType !== 'fx' && this.detailData.outType !== '--' && Number(this.detailData.diffFundPriceAccount) <= 0) {
          console.log('111asd222222');
          this.isDiffFundPrice = false;
          return this.$message.error("当前差异基金金额为0，不可设置")
        }
        this.submitData.diffFundPrice = "";
      } else {
        this.submitData.diffFundPrice = null;
      }
    }
  },

  mounted() {
    this.getData();
    this.getExtraDetatil()
  },

  methods: {
    getRejectMark,
    // 限制数字，保留两位数
    getFloat2Value,
    openAction,

    getExtraDetatil() {
      http.extraDetatil({ argueNoExtra: this.argueNoExtra }).then(res => {
        // res.data.state = '10'
        // res.data.rejectMark = '15'

        this.extraDetatil = res.data
        const { auditFirstPrice, rePayPrice,
          rejectCause, state, rejectMark,
          moneyWay, moneyUseType, diffFundPrice, deStoreBalance
        } = res.data
        console.log('moneyUseType', moneyUseType);

        if (state == '00') {
          this.auditFirstDisabled = false
          this.auditReShow = false
        } else if (state == '10') {
          this.auditFirstDisabled = true
          this.auditReShow = true
          this.auditReDisabled = false
          this.extraForm = {
            auditFirstPrice,
            auditFirstIfPass: true,
            auditReIfPass: true,
            rePayPrice: '',
            moneyWay: '01'
          }
        } else if (state == '20') {
          if (moneyUseType == '00') {
            this.isFund = true
            this.isDeBalanceVoucher = false
          } else if (moneyUseType == '01') {
            this.isFund = false
            this.isDeBalanceVoucher = true
          } else if (moneyUseType == '02') {
            this.isFund = true
            this.isDeBalanceVoucher = true
          }
          this.auditFirstDisabled = true
          this.auditReShow = true
          this.auditReDisabled = true
          this.extraForm = {
            auditFirstIfPass: true,
            auditFirstPrice,
            auditReIfPass: true,
            rePayPrice,
            moneyWay,
            diffFundPrice,
            deStoreBalance
          }
        } else if (state == '40') {
          if (rejectMark == '05') {
            this.auditFirstDisabled = true
            this.auditReShow = false
            this.extraForm = {
              auditFirstIfPass: false,
              rejectCause
            }
          } else if (rejectMark == '15') {
            this.auditFirstDisabled = true
            this.auditReShow = true
            this.auditReDisabled = true
            this.extraForm = {
              auditFirstIfPass: true,
              auditFirstPrice,
              auditReIfPass: false,
              rejectCause
            }
          }

        }
      })
      console.log('deBalanceVoucherProps2', this.deBalanceVoucherProps.show);

    },
    isDeBalanceVoucherChange() {
      // 余额的开通
      if (this.isDeBalanceVoucher) {

        this.deBalanceVoucherProps.isView = false;
        this.deBalanceVoucherProps = {
          ...this.deBalanceVoucherProps,
          isView: false,
          show: true,
          title: "确认扣款商户余额",
          headerMessage: "说明：请谨慎确认追差款项从商户余额扣款，并上传沟通凭证",
        };
      } else {
        this.deBalanceVoucherProps.isView = false;
        this.deBalanceSumit = {
          ...this.deBalanceVoucherProps,
          voucher: "",
          money: null,
          title: "确认扣款商户余额",
          headerMessage: "说明：请谨慎确认追差款项从商户余额扣款，并上传沟通凭证",
          isEdit: false
        };
        this.submitData.deStoreBalance = null;
      }
      console.log('deBalanceVoucherProps4', this.deBalanceVoucherProps.show);
    },
    // 刷新
    refreshData() {
      // 总差异基金
      this.getAllDiffFund()
      this.getMerchantDiffFund()
    },
    // 获取当前总差异基金 this.infoData
    getAllDiffFund() {
      _api.getAllDiffFund().then(res => {
        if (res.code === 1) {
          console.log(res, '当前总差异基金');
          this.allDiffFund = res.data
        }
      })
    },
    // 回收商总差异基金
    getMerchantDiffFund() {
      _api.merchantDiffFund({ merchantId: this.infoData.merchantId }).then(res => {
        this.merchantDiffFund = res.data
      })
    },
    // 复核打款-差异基金可扣成负数
    inputDiffFundPrice(v) {
      // 限制输入diffFundPrice放开
      // console.log(this.detailData, 'hahahaha哈哈啊哈');
      // if (this.detailData.outType !== 'fx' && this.detailData.outType !== '--') {
      //   if (this.detailData.diffFundPriceAccount <= 0) {
      //     this.extraForm.diffFundPrice = 0
      //   }
      // }
    },




    // 申请信息
    getData() {
      // 审核详情
      _api.aprDetatil({ argueNo: this.argueNo }).then(r => {
        // 暂时假数据
        let data = r.data ?? {};
        data = {
          ...data,
          vouchers: Array.isArray(data.vouchers) ? data.vouchers : [],
          stateText: data.isPlatformHandle ? getAprState(data.state) : getAprStateStore(data.state),
          items: Array.isArray(data.items) ? data.items.join(",") : data.items,
          applyStaffInfo: infoConcat(data.applyStaffName, data.applyStaffMobile),
          // 打款人
          // payStaffInfo: infoConcat(data.payStaffName, data.payStaffMobile),
          payStaffInfo: infoConcat('审核员', `${data.payStaffMobile ? data.payStaffMobile.slice(0, 3) + '***' + data.payStaffMobile.slice(-4) : ''}`),
          cancelStaffInfo: infoConcat(data.cancelStaffName, data.cancelStaffPhone),
          // auditReAdminInfoP: infoConcat(data.auditReAdminName, data.auditReAdminPhone),
          auditReAdminInfoP: !data.isPlatformHandle ? infoConcat('审核员', data.auditReAdminPhone) : '审核员',
          auditReAdminInfo: !data.isPlatformHandle ? infoConcat('审核员', `${data.auditReAdminPhone ? data.auditReAdminPhone.slice(0, 3) + '***' + data.auditReAdminPhone.slice(-4) : ''}`) : '审核员',
          // 修改：取审核员（固定称谓）-人员手机号（中间4位默认加密）data.auditFirstAdminName auditFirstAdminAcc
          // auditFirstAdminInfo: infoConcat('审核员', `${data.auditFirstAdminPhone ? data.auditFirstAdminPhone.slice(0, 3) + '***' + data.auditFirstAdminPhone.slice(-4) : ''}`),
          auditFirstAdminInfo: !data.isPlatformHandle ? infoConcat('审核员', `${data.auditFirstAdminPhone ? data.auditFirstAdminPhone.slice(0, 3) + '***' + data.auditFirstAdminPhone.slice(-4) : ''}`) : '审核员',
          rejectAdminInfo: infoConcat(data.rejectAdminName, data.rejectAdminAcc),
          rejectStaffInfo: infoConcat(data.rejectStaffName, data.rejectStaffMobile),

          undertakeSubjectText: getUndertakeSubject(data.undertakeSubject),
        }
        // 审核详情
        http.flowDetail({ argueNo: this.argueNo }).then(r => {

          let pview = r.data.pview ?? {}
          data = {
            ...data,
            pview
          }
          data = setValue(data);
          this.detailData = data;
        })
        // data = setValue(data);
        // this.detailData = data;
        this.getInfo(data.orderNo);
      });
      console.log('deBalanceVoucherProps3', this.deBalanceVoucherProps.show);

    },



    // 父组件统一管理数据(订单信息)
    getInfo(orderNo) {
      _api.orderInfo({ orderNo }).then(r => {
        let data = r.data ?? {};
        data = {
          ...this.imeiTestProps,
          ...data,
          funcDetail: data.funcDetail ?? { machineName: '--' },
          // *********新加的
          sku: data.sku ?? { skus: [] },//外部规格
          functionList: data.coreFaults ?? [],//功能列表
          isSystem: data.detectionType === '02' && data.detectionInfo,//检测类型
          unableDetectionCause: data.unableDetectionCause,//是否系统检测
          detectionInfo: data.detectionInfo ?? {},//检测结果
          orderMode: data.orderMode,//预估价模式
          phoneName: data.phoneName,
          remark: data.remark,//下单备注
          againPhotoRemark: data.againPhotoRemark,//补拍备注
          // *********************
          staffInfo: infoConcat(data.staffName, data.staffMobile),
          images: data.images && data.images != null ? data.images?.map(v => {
            return {
              mediaUrl: v.originalImg,
              mediaType: 'image',
              imgWay: v.imgWay
            }
          }) : []
        }
        console.log(data.reImages, "补拍图片")
        if (data.reImages) {
          data.reImages.forEach(item => {
            data.images.unshift({
              mediaUrl: item.originalImg,
              mediaType: 'image',
              imgWay: item.imgWay
            })
          })
        }
        this.infoData = setValue(data);
        console.log('this.infoData', this.infoData);

        this.setFunctionType(data);
        this.setFunctionData(data);
        // 总差异基金
        this.getAllDiffFund()
        this.getMerchantDiffFund()
      })
    },
    //功能情况设置显示值
    setFunctionType(v) {
      let { isSystem, unableDetectionCause, functionList, isOtherTitileShow } = this.imeiTestProps;
      // 其他功能 系统检测||无法检测&&功能项存在&&（不是采货侠或者是采货侠订单且外部渠道为fx）
      if ((isSystem || unableDetectionCause) && functionList.length && (!v.isOneline || (v.isOneline && v.outType === 'fx'))) {
        isOtherTitileShow = true;
      } else {
        isOtherTitileShow = false;
      }
      this.imeiTestProps.isOtherTitileShow = isOtherTitileShow;
      // 02不是采货侠或者是采货侠订单且外部渠道为fx
      if (!v.isOneline || (v.isOneline && v.outType === 'fx')) {
        return this.imeiTestProps.type = '02';
      }
    },

    // 上述02类型  外部渠道盛达lb或者lb2，屏蔽正常开机选项
    setFunctionData(v) {
      const fineness = v.fineness ?? { fineness: [] };
      v.detectionInfo = v.detectionInfo ?? {};
      let { isFinenessShow, functionList, systemTestList, photoArr, allSystemTestList } = this.imeiTestProps;
      const { cameraTestImgFront, cameraTestImgRear } = v.detectionInfo;
      systemTestList = JSON.parse(JSON.stringify(allSystemTestList));
      let finenessData = Array.isArray(fineness.fineness) ? fineness.fineness : [];
      functionList = Array.isArray(functionList) ? functionList : [];
      // 盛达外部去除是否开机
      if (v.outType === 'lb' || v.outType === 'lb2') {
        functionList = functionList.filter(v => v.faultName !== '是否正常开机');
      }
      // 成色渲染 是采货侠 && 并且存在成色数据
      if (v.isOneline && fineness && finenessData.length) {
        isFinenessShow = true;
        finenessData = Array.isArray(finenessData) ? finenessData : [];
        finenessData = finenessData ? finenessData.map(item => {
          if (v.outType === 'lb' || v.outType === 'lb2') {
            item.value = item.value ?? [];
            item.value = item.value ? item.value?.map(v => {
              return {
                valueText: v.isNormal ? '正常' : '异常',
                isNormal: v.isNormal
              }
            }) : []
          }
          return {
            name: item.label,
            value: item.value
          }
        }) : []
      } else {
        isFinenessShow = false;
      }
      // 设置功能机
      functionList = functionList ? functionList?.map(v => {
        return {
          name: v.faultName,
          state: v.faultAnswer,
          reason: v.faultCause
        }
      }) : []
      // 检测类型动态更改值的key
      const systemKeys = ['mobileNetworks', 'wlan', 'bluetooth'];
      if (v.detectionInfo) {
        // 设置系统验机项
        systemTestList = systemTestList ? systemTestList?.map(item => {
          item.value = v.detectionInfo[item.key] ?? '--';
          //前三个，正常的就是系统验机，异常的话是人工验机
          if (systemKeys.indexOf(item.key) >= 0) {
            if (v.detectionInfo[item.key] === '01') {
              item.isSystem = true;
            } else {
              item.isSystem = false;
            }
          }
          // 存在值才进行替换
          if (v.detectionInfo[item.tipKey]) {
            item.tips = v.detectionInfo[item.tipKey].replaceAll("&", "       ")
          }
          return item
        }) : []
      }


      // 设置前置旧机照片
      if (cameraTestImgFront) {
        photoArr.push(cameraTestImgFront)
      }
      // 设置后置
      if (cameraTestImgRear) {
        photoArr.push(cameraTestImgRear)
      }
      this.imeiTestProps = {
        ...this.imeiTestProps,
        functionList,
        isFinenessShow,
        finenessData,
        systemTestList,
        photoArr,
      };
    },
    // 值回显
    resultEcho() {
      let { state, undertakeSubject, judgements, merchantSuggest, companySuggest, arguePriceAuditS } = this.detailData;
      if (state !== '00') {
        this.submitData = {
          ...this.submitData,
          undertakeSubject,
          merchantSuggest,
          companySuggest,
          arguePriceAudit: arguePriceAuditS
        }
        judgements = Array.isArray(judgements) ? judgements : [];
        judgements = judgements ? judgements?.map(v => {
          return {
            ...v,
            url: v.mediaUrl,
          }
        }) : []
        // 责任
        if (undertakeSubject !== 'T') {
          this.submitData.judgements = judgements;
        } else {
          this.tabSquare = '01';
          this.storeJudgements = judgements.filter(v => v.judgeType === '00');
          this.recoveryJudgements = judgements.filter(v => v.judgeType === '01');
          this.submitData.judgements = this.storeJudgements;
        }
      }
    },

    // 余额确定开启
    diffFundConfig() {
      console.log('deBalanceVoucherProps5', this.deBalanceVoucherProps.show);

      const { money, voucher } = this.deBalanceSumit;
      if (this.deBalanceVoucherProps.isView) {
        return this.deBalanceVoucherProps.show = false;
      }
      if (!money && money !== 0) {
        return this.$message.error("请输入扣款金额");
      }
      if (!voucher) {
        return this.$message.error("请选择上传凭证")
      }
      this.deBalanceVoucherProps.show = false;
      this.isDeBalanceVoucher = true;
      this.deBalanceSumit.isEdit = true;
      this.extraForm.deStoreBalance = this.deBalanceSumit.money;
      this.submitData.deBalanceVoucher = this.deBalanceSumit.voucher;
    },
    // 关闭余额弹窗
    deBalanceVoucherClose() {
      console.log('deBalanceVoucherProps6', this.deBalanceVoucherProps.show);
      this.deBalanceVoucherProps.show = false;
      this.deBalanceSumit.money = this.submitData.deStoreBalance;
      this.deBalanceSumit.voucher = this.submitData.deBalanceVoucher;
      if (this.isDeBalanceVoucher && !this.deBalanceSumit.isEdit) {
        this.isDeBalanceVoucher = false;
      }
    },
    submitDialog() {
      this.submitVisible = true
    },
    // 提交
    submit() {
      console.log(1);
      const { argueNo, argueNoExtra, orderNo, state } = this.extraDetatil

      if (state == '00') {
        const { auditFirstIfPass, auditFirstPrice, rejectCause } = this.extraForm
        let ifPass
        console.log('this.extraForm', this.extraForm);

        if (auditFirstIfPass) {
          ifPass = true
        } else {
          ifPass = false
        }
        console.log({
          argueNo, argueNoExtra, orderNo,
          ifPass,
          arguePriceAudit: ifPass ? auditFirstPrice : null,
          rejectCause: !ifPass ? rejectCause : null
        }, 111);
        const submitOBJ = {
          argueNo, argueNoExtra, orderNo,
          ifPass,
          arguePriceAudit: ifPass ? auditFirstPrice : null,
          rejectCause: !ifPass ? rejectCause : null
        }
        console.log('ifPass', ifPass);
        console.log('submitOBJ.rejectCause', submitOBJ.rejectCause);
        if ((ifPass && !submitOBJ.arguePriceAudit) || (!ifPass && !submitOBJ.rejectCause)) {
          this.$message({
            message: '请完整填写再提交',
            type: 'warning'
          });
          return
        }
        this.submitLoading = true
        http.auditFirst(submitOBJ).then(res => {
          this.submitLoading = false
          location.reload();
          this.$message({
            message: '保存操作已成功',
            type: 'success'
          });
        }).catch((err) => {
          this.submitLoading = false

        });

      } else if (state == '10') {
        let { auditReIfPass, rePayPrice, rejectCause,
          moneyWay, diffFundPrice, deStoreBalance } = this.extraForm
        let ifPass, moneyUseType, offlinePrice
        if (auditReIfPass) {
          ifPass = true
        } else {
          ifPass = false
        }
        if (!ifPass) {
          moneyWay = null
          moneyUseType = null
          offlinePrice = null
          diffFundPrice = null
          deStoreBalance = null
        } else {
          moneyUseType = this.isFund && this.isDeBalanceVoucher ? '02' : !this.isFund && this.isDeBalanceVoucher ? '01' : '00'

        }
        console.log({
          argueNo, argueNoExtra, orderNo,
          ifPass,
          arguePriceAudit: ifPass ? rePayPrice : null,
          rejectCause: !ifPass ? rejectCause : null,
          moneyWay,
          moneyUseType: moneyWay == '00' ? null : moneyUseType,
          offlinePrice: moneyWay == '00' ? rePayPrice : null,
          diffFundPrice: this.isFund ? diffFundPrice : null,
          deStoreBalance: this.isDeBalanceVoucher ? deStoreBalance : null,
        }, 222);
        const submitOBJ = {
          argueNo, argueNoExtra, orderNo,
          ifPass,
          arguePriceAudit: ifPass ? rePayPrice : null,
          rejectCause: !ifPass ? rejectCause : null,
          moneyWay,
          moneyUseType: this.isFund && this.isDeBalanceVoucher ? '02' : !this.isFund && this.isDeBalanceVoucher ? '01' : '00',
          offlinePrice: moneyWay == '00' ? rePayPrice : null,
          diffFundPrice: this.isFund ? diffFundPrice : null,
          deStoreBalance: this.isDeBalanceVoucher ? deStoreBalance : null,
        }
        console.log('ifPass', ifPass);
        console.log('submitOBJ.rejectCause', submitOBJ.rejectCause);
        if ((ifPass && !submitOBJ.arguePriceAudit) || (!ifPass && !submitOBJ.rejectCause)) {
          this.$message({
            message: '请完整填写再提交',
            type: 'warning'
          });
          return
        }
        this.submitLoading = true
        http.auditRe(submitOBJ).then(res => {
          this.submitLoading = false
          location.reload();
          this.$message({
            message: '保存操作已成功',
            type: 'success'
          });
        }).catch((err) => {
          this.submitLoading = false

        });
      }

    },

    // 切换矩阵
    matrixSwitch() {
      let orderNo = "";
      this.isMatrix = !this.isMatrix;
      if (this.isMatrix) {
        orderNo = this.detailData.orderNo;
      } else {
        orderNo = this.detailData.orderNoOneline;
      }
      this.getInfo(orderNo)
    },

    //利润计算
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    // 初审依据
    firstJudgements() {
      let { undertakeSubject, judgements } = this.detailData.pview;
      this.firstRejectProp = {
        ...this.firstRejectProp,
        show: true,
        tabSquare: "01",
        rejectText: this.getRejectText(undertakeSubject),
        undertakeSubject
      }
      judgements = Array.isArray(judgements) ? judgements : [];
      judgements = judgements ? judgements?.map(v => {
        return {
          ...v,
          url: v.mediaUrl,
          state: '00'
        }
      }) : []
      this.firstRejectProp.judgements = judgements;
      if (undertakeSubject === 'T') {
        this.firstRejectProp.sourceData = judgements.filter(v => v.judgeType === '00');
      } else {
        this.firstRejectProp.sourceData = judgements;
      }
    },
    getRejectText(v) {
      switch (v) {
        case "C":
          return "门店责任";
        case "T":
          return "双方共同责任";
        default:
          return "回收商责任（驳回追差）";
      }
    },
    tabSquareClick(v) {
      const { assignmentData, judgements } = this.firstRejectProp;
      this.firstRejectProp = {
        ...this.firstRejectProp,
        tabSquare: v
      }
      if (v === '01') {
        this.firstRejectProp.assignmentData = judgements.filter(v => v.judgeType === '00');
      } else {
        this.firstRejectProp.assignmentData = judgements.filter(v => v.judgeType === '01')
      }
    },

  },
}
</script>

<style scoped lang="scss">
.statatics {
  margin-left: 40px;
  background-color: #fff;
  padding: 15px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  display: flex;
  align-items: center;
}

.permit_tex {
  color: #0981FF;
  font-weight: 700;
  margin-right: 30px;
}

.permit_see {
  margin-top: 17px;
  width: 100%;
  background: #F5F6FA;
  border-radius: 4px;
  padding: 21px 26px 23px 20px;
  box-sizing: border-box;

  overflow: auto;

  /deep/ .el-switch__label * {
    line-height: 1;
    font-size: 12px;
    display: inline-block;
  }

  /deep/ .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
    font-size: 12px !important;
  }

  /*打开时文字位置设置*/
  /deep/ .el-switch__label--right {
    z-index: 1;
    // right: 4px;
  }

  /*关闭时文字位置设置*/
  /deep/ .el-switch__label--left {
    z-index: 1;
    left: 22px;
  }

  /*显示文字*/
  /deep/ .el-switch__label.is-active {
    display: block;
  }

  /*开关宽度*/
  /deep/ .el-switch .el-switch__core,
  /deep/ .el-switch .el-switch__label {
    width: 50px !important;
  }
}

.temporary {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}

.box {
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    >img {
      width: 30px;
      height: 30px;
    }

    >p {
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      margin-left: 6px;
      margin-right: 6px;
    }

    >span {
      font-size: 16px;
      font-weight: 400;
      color: #FF8A00;
    }
  }
}

.examine_box {
  margin-top: 18px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 17px 20px 35px 20px;
  box-sizing: border-box;
}

.examine {
  // margin-top: 18px;
  // width: 100%;
  // background: #FFFFFF;
  // border-radius: 4px;
  // padding: 17px 20px 35px 20px;
  // box-sizing: border-box;
  display: flex;

  .examine-inner {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    width: 50%;
  }

  .examine_left {
    min-width: calc(50% - 22px);
    max-width: calc(50% - 22px);
    width: calc(50% - 22px);
    box-sizing: content-box;
    padding-right: 22px;
  }

  .examine_main {
    margin-top: 17px;
    width: 100%;
    background: #F5F6FA;
    border-radius: 4px;
    padding: 21px 26px 23px 20px;
    box-sizing: border-box;
    max-height: 400px;
    min-height: 400px;
    height: 400px;
    overflow: auto;
  }

  .examine_right_input {
    width: 100%;

    &:last-of-type {
      margin-bottom: 0;
    }

    margin-bottom: 20px;

    .examine_right_title {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
    }

    textarea {
      margin-top: 16px;
      width: 100%;
      height: 120px;
      padding: 12px 13px;
      box-sizing: border-box;
      background: #F9FBFD;
      border: 1px solid #C1D1FF;
      border-radius: 4px;

      &:focus {
        outline: none;
      }
    }
  }
}

.responsibility {
  display: flex;
  align-items: center;

  .responsibility_select {
    display: flex;
    align-items: center;

    >div {
      margin-right: 25px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    img {
      margin-right: 6px;
    }

    span {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }
  }
}

.responsibility_category {
  width: 196px;
  height: 30px;
  box-sizing: content-box;
  background: #F9FBFD;
  border: 1px solid #C1D1FF;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin-top: 24px;

  >p {
    width: 50%;
    height: 30px;
    border-radius: 5px;
    text-align: center;
    background: #F9FBFD;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
    cursor: pointer;
  }

  .responsibility_category_active {
    background: #4C84FF;
    color: #FFFFFF;

  }
}

.money_original {
  margin-top: 24px;
  font-size: 14px;
}

.judgements_box {
  margin-top: 24px;
}

.responsibility_title {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}

.click_hover:hover {
  opacity: 0.8;
}

.info_title {
  font-size: 16px;
  font-weight: 600;
  color: #4C84FF;
  position: relative;
  padding-left: 7px;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 4px;
    width: 2px;
    height: 14px;
    background: #4C84FF;
    border-radius: 1px;
  }
}

.check_money_box {
  background: #FFFFFF;
  border-radius: 4px;
  padding: 19px 22px 25px 20px;
  box-sizing: border-box;
  margin-top: 18px;
  width: 100%;

  >.check_money_title {
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #FD677D;
  }

  >.check_money_main {
    width: 100%;
    background: #F5F6FA;
    border-radius: 4px;
    padding: 24px 35px 31px 21px;
    box-sizing: border-box;
  }
}

.check_money_money {
  color: #333;
  font-size: 14px;
  margin-left: 29px;

  >span {
    color: #999;
  }
}

.element_xing {
  position: relative;
  padding-left: 8px;

  &::after {
    content: "*";
    display: inline-block;
    position: absolute;
    left: 0;
    top: 3px;
    color: #F80000;
  }
}

.voucher_box {
  margin-top: 30px;

  >p {
    margin-top: 10px;
    color: #333;
    margin-bottom: 10px;
    font-size: 12px;
  }
}

.check_money_btn {
  margin-top: 28px;
  display: flex;
  align-items: center;
  padding-left: 8px;

  >div {
    margin-right: 100px;
    cursor: pointer;
  }

  .direct_btn {
    width: 110px;
    height: 40px;
    background: #FD677D;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    position: relative;
    text-align: center;
    line-height: 40px;

    &:after {
      content: "谨慎操作";
      position: absolute;
      z-index: 1;
      right: -47px;
      height: 20px;
      line-height: 20px;
      top: -14px;
      padding: 0px 10px 0px 8px;
      box-sizing: border-box;
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      background: #FFAF29;
      border-radius: 10px 10px 10px 0px;
    }
  }

  .submit_btn {
    width: 100px;
    height: 40px;
    background: #4C84FF;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    position: relative;
    text-align: center;
    line-height: 40px;

    &:after {
      content: "先由门店确认打款";
      position: absolute;
      z-index: 1;
      right: -97px;
      height: 20px;
      line-height: 20px;
      top: -14px;
      padding: 0px 10px 0px 8px;
      box-sizing: border-box;
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      background: #FFAF29;
      border-radius: 10px 10px 10px 0px;
    }
  }

  .submit_btn {
    width: 100px;
    height: 40px;
    background: #4C84FF;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    position: relative;
    text-align: center;
    line-height: 40px;

    &:after {
      content: "先由门店确认打款";
      position: absolute;
      z-index: 1;
      right: -97px;
      height: 20px;
      line-height: 20px;
      top: -14px;
      padding: 0px 10px 0px 8px;
      box-sizing: border-box;
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      background: #FFAF29;
      border-radius: 10px 10px 10px 0px;
    }
  }

  .no_submit_btn {
    &::after {
      content: '本单门店无需打款';
      background: #21D8C2;
    }
  }
}

.offline_submit {
  cursor: pointer;
  margin-top: 28px;
  margin-left: 15px;
  width: 100px;
  height: 40px;
  background: #4C84FF;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  position: relative;
  text-align: center;
  line-height: 40px;

  &:after {
    content: "线下已打款";
    position: absolute;
    z-index: 1;
    right: -78px;
    height: 20px;
    line-height: 20px;
    top: -14px;
    padding: 0px 10px 0px 8px;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 400;
    color: red;
    text-align: center;
    // background: #FFAF29;
    border: 1px solid red;
    border-radius: 10px 10px 10px 0px;
  }
}

.result_data {
  display: flex;
  width: 100%;
  background: #fff;
  margin-top: 43px;
  padding: 17px 20px 30px 20px;
  box-sizing: border-box;
  border-radius: 4px;
  justify-content: space-between;
  flex-wrap: wrap;

  >div {
    margin-bottom: 22px;
    flex: 1;
    width: 49%;
    max-width: 49%;
    min-width: 49%;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .result_data_main {
    width: 100%;
    background: #F5F6FA;
    border-radius: 4px;
    padding: 26px 28px 24px 19px;
    box-sizing: border-box;
  }
}

.inner_line {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  font-size: 14px;
}

.inner_href_text {
  color: #4C84FF;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}

/* 设置滚动条的宽度、高度、背景色和边框样式 */
::-webkit-scrollbar {
  width: 12px;
}

/* 设置滚动条滑块的背景色和圆角 */
::-webkit-scrollbar-thumb {
  background-color: #DCE0EE;
  height: 10px;
  border-radius: 4px;
}

/* 设置滚动条滑块在悬停状态下的背景色和圆角 */
//::-webkit-scrollbar-thumb:hover {
//  height: 10px;
//}

/* 设置滚动条轨道的背景色和圆角 */
::-webkit-scrollbar-track {
  background-color: rgba(220, 224, 238, .5);
}

/* 设置滚动条轨道在悬停状态下的背景色和圆角 */
//::-webkit-scrollbar-track:hover {
//  background-color: #ccc;
//  border-radius: 5px;
//}

//去除数字框上下箭头
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type='number'] {
  -moz-appearance: textfield;
}

.inner_title_red {
  color: #FD677D;
}

.inner_label {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}

.inner_href_text {
  color: #4C84FF;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}


.disable_result {
  border-color: #eee !important;
  background: #eee !important;
  cursor: no-drop !important;
}

.submit_box {
  margin-top: 27px;
}

.rejetct_box {
  .reject_duty {
    display: flex;
    align-items: center;
  }

  .reject_basis {
    margin-top: 10px;

    /deep/ .box .list_box p {
      width: 80px;
    }
  }
}

.store_box {
  background: #fff;
  padding: 16px 20px 31px 20px;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  margin-top: 25px;

  .store_line {
    display: flex;
    align-items: center;
    margin-right: 6px;

    .style_line {
      max-width: 414px;
      width: 414px;
      min-width: 414px;
      display: flex;
      align-items: center;

      >div {
        flex: 1;
      }

      >div:first-of-type {
        max-width: 15px;
        max-height: 15px;
        text-align: center;
        background: #4C84FF;
        border-radius: 50%;
        font-size: 12px;
        font-weight: 500;
        color: #FFFFFF;
        margin-right: 4px;
      }

      >div:nth-of-type(2) {
        max-width: 67px;
        font-size: 16px;
        font-weight: 400;
        color: #4C84FF;
      }

      >.progress_bar {
        flex: 1;
        height: 2px;
        background: #4C84FF;
        margin-right: 4px;
      }
    }
  }

  .store_main_style {
    display: flex;
    margin-top: 18px;

    .store_result_style {
      min-width: 392px;
      // max-width: 392px;
      width: 392px;
      padding: 23px 18px 19px 21px;
      box-sizing: border-box;
      background: #F5F6FA;
      border-radius: 4px;
      margin-right: 22px;

      >div:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

.empty {
  text-align: center;

  img {
    width: 96px;
    height: 50px;
    margin: 0 auto;
    margin-top: 30px;
    display: block;
  }
}

.check_money_btn>div.loading {
  position: relative;
  cursor: default;
}

.check_money_btn>div.loading::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  //transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .2);
  //border: 2px solid white;
  //border-top: 2px solid transparent;
  //border-radius: 50%;
  //animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.enable-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }

  .set_top_ck {
    span {
      font-size: 15px;
      font-weight: bold;
      margin-right: 10px;
    }
  }
}

.command {
  display: flex;
  align-items: center;
}
</style>
